(function () {
    document.addEventListener('DOMContentLoaded', function () {
        // Only run on CWC posts
        var cwcContent = document.querySelector('.cwc-content-body');
        if (!cwcContent) return;

        var blockquotes = cwcContent.querySelectorAll('blockquote');

        // 1. Speaker Detection Logic
        blockquotes.forEach(function (blockquote, index) {
            var firstP = blockquote.querySelector('p');
            var textNode = firstP ? firstP : blockquote;
            var text = textNode.innerHTML.trim();

            var williamRegex = /^(?:<strong>)?\s*WILLIAM:?\s*(?:<\/strong>)?\s*/i;
            var chatgptRegex = /^(?:<strong>)?\s*(?:CHATGPT|CODE):?\s*(?:<\/strong>)?\s*/i;
            var narratorRegex = /^(?:<strong>)?\s*NARRATOR:?\s*(?:<\/strong>)?\s*/i;

            function cleanText(originalText, regex) {
                var noSpeaker = originalText.replace(regex, '');
                return noSpeaker.replace(/^(?:\s*<br\s*\/?>\s*)+/i, '');
            }

            if (williamRegex.test(text)) {
                blockquote.setAttribute('data-speaker', 'william');
                textNode.innerHTML = cleanText(text, williamRegex);
            } else if (chatgptRegex.test(text)) {
                blockquote.setAttribute('data-speaker', 'chatgpt');
                textNode.innerHTML = cleanText(text, chatgptRegex);
            } else if (narratorRegex.test(text)) {
                blockquote.setAttribute('data-speaker', 'narrator');
                textNode.innerHTML = cleanText(text, narratorRegex);
            } else {
                // Continuation Logic: Check "logical" previous blockquote in the list
                if (index > 0) {
                    var prevQuote = blockquotes[index - 1];

                    // Verify they are somewhat adjacent (optional, but good for safety)
                    // If there's a huge gap of text between blockquotes, don't merge.
                    // Checking if they are siblings or close:
                    var areSiblings = (blockquote.previousElementSibling === prevQuote);

                    if (areSiblings && prevQuote.hasAttribute('data-speaker')) {
                        var prevSpeaker = prevQuote.getAttribute('data-speaker');

                        // Only continue for bubbles
                        if (prevSpeaker === 'william' || prevSpeaker === 'chatgpt' || prevSpeaker === 'code') {
                            blockquote.setAttribute('data-speaker', prevSpeaker);
                            blockquote.classList.add('cwc-continuation');

                            // Mark previous one to square its bottom corners
                            prevQuote.classList.add('cwc-has-continuation');
                        }
                    }
                }
            }

            // Prepare for animation
            blockquote.classList.add('cwc-bubble');
        });

        // 2. Intersection Observer for Pop-in Animation
        if ('IntersectionObserver' in window) {
            var observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            };

            var observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                        observer.unobserve(entry.target); // Run once
                    }
                });
            }, observerOptions);

            blockquotes.forEach(function (blockquote) {
                // Only animate if it's a speaker bubble, not plain narrator text
                if (blockquote.hasAttribute('data-speaker') && blockquote.getAttribute('data-speaker') !== 'narrator') {
                    observer.observe(blockquote);
                } else {
                    // Narrator or unknown: visible immediately
                    blockquote.classList.add('is-visible');
                }
            });
        } else {
            // Fallback for browsers without IntersectionObserver
            blockquotes.forEach(function (bq) {
                bq.classList.add('is-visible');
            });
        }
    });
})();
